export enum InboxRoutes {
    InboxList = ''
}
